<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
		<v-col class="pa-0">
            <show
                :id="id"
                :models="models"
                model-def="maillists"
                model-class="maillist"
                :infos="infos"
                top-class=""
                :activities="true">
            
                <template slot="relations">
                    <belongstomany-show
                        class="pb-4"
                        :headers="headers"
                        title="Anagrafiche"
                        paginate
                        :url="'company-maillists-filters'"
                        :subFilters="{'list_id': id}">
                        <template slot="table-footer">
                            <v-row class="pa-0 ma-0"  justify="center">
                                <v-col lg="2" md="4" sm="6" class="pt-0">						
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mail</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>Totale Anagrafiche</v-list-item-title>
                                                <v-list-item-subtitle>{{ countCompanies }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                                <v-col lg="2" md="2" sm="6" class="pt-0">						
                                    <v-list two-line class="background-2">
                                        <v-list-item>
                                            <v-list-item-action>
                                                <v-icon color="primary">mail</v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ isPec ? 'Totale PEC' : 'Totale Mail' }}</v-list-item-title>
                                                <v-list-item-subtitle>{{ countCompaniesEmail }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </template>
                    </belongstomany-show>
                </template>
            </show>
        </v-col>
    </v-row>
</template>

<script>

    import BelongstomanyShow from '@/components/common/BelongstomanyShow'

    export default {

        name: 'maillist',
        components: {
            BelongstomanyShow
        },

        props: {
            id: Number,
        },

        data() {
            return {
                infos: {},
                models: {},
                relations: {},
                modelDef: 'maillists',
            }
        },
        

        computed: {

            isPec() {
                return !!this.models.maillist && this.models.maillist.type === 'pec'
            },

            headers() {
                return [
                    {
                        'text': '#',
                        'sortable': false,
                        'value': 'number',
                        'width': '40'                        
                    },
                    {
                        // Su una lista PEC il backend restituisce la PEC in primary_email
                        'text': this.isPec ? 'PEC' : 'Email',
                        'sortable': false,
                        'value': 'primary_email',                        
                    },
                    {
                        'text': 'Anagrafica',
                        'sortable': false,
                        'value': 'company',
                    },
                    {
                        'text': 'Data Iscrizione',
                        'sortable': false,
                        'value': 'created_at',
                        'type': 'date',
                    }
                ]
            },

            countCompanies() {
                if(this.models.maillist && this.models.maillist.companies_count) {
                    return this.models.maillist.companies_count
                } else return 0
            },

            countCompaniesEmail() {
                if(this.models.maillist && this.models.maillist.companies_count) {
                    return this.models.maillist.companies_count_email
                } else return 0
            },
        },

        created() {
            this.axios.get(this.modelDef + '/' + this.id).then(response => {
                this.models = response.data.models
                this.infos = response.data.infos
                // this.relations = response.data.relations
                this.$store.commit('endProgress')
                this.load = true

            }, response => {
                // error callback
            })               
        }
    }
</script>
